import { createFormHookContexts } from '@tanstack/react-form';

export const { useFieldContext, formContext, fieldContext } = createFormHookContexts();
